export  const  linksConfig ={
    link: {
   apilink:"https://secnav.daimlertruck.com/api",
    // apilink:'http://localhost:5000'
    // apilink:"https://aztestactions2.azurewebsites.net"
          
    }
};